import { Navigate, useNavigate, useParams } from "react-router-dom";
import { useRecoilValue } from "recoil";
import { userAtom } from "recoil/userAtom";
import { getPromotionBySlug } from "../../components/task/payment/planTypes";
import PaymentContentPartner from "../../components/task/payment/PaymentContentPartner";
import CustomModal from "components/common/CustomModal";

// 제휴(파트너) PC 결제 단독 페이지.
// - 미지원 slug → 홈
// - 이미 구독 중(로그인 + subscription.isSubscribing) → 중복 결제 방지:
//   PaymentContentPartner(주문 조회/자동 토스) 자체를 마운트하지 않고 모달만 띄워 홈으로
// - 그 외: PaymentContentPartner (로그아웃 표시 → 로그인 → 인라인 토스)
export default function PartnerPayment() {
  const { slug } = useParams();
  const navigate = useNavigate();
  const user = useRecoilValue(userAtom);
  const promotion = getPromotionBySlug(slug);

  if (!slug || !promotion) return <Navigate to="/" replace />;

  const isAlreadySubscribing =
    !!user?.accessToken && user?.subscription?.isSubscribing === true;

  if (isAlreadySubscribing) {
    return (
      <CustomModal
        open
        onClose={() => navigate("/", { replace: true })}
        title={"이미 이용 중이에요"}
        subtitle={"현재 이용 중이라 추가 결제가 필요하지 않아요."}
        actions={[
          {
            label: "확인",
            variant: "Solid",
            onClick: () => navigate("/", { replace: true }),
          },
        ]}
        isMobile={true}
      />
    );
  }

  return <PaymentContentPartner partnerSlug={slug} />;
}
